// Buy Once / Subscribe toggle: shows the subscribe panel and enables the
// selling_plan menu only while Subscribe is selected. The menu only contains
// Shopify Subscriptions app plans (filtered in blocks/subscription-picker.liquid);
// Subscribe always has an allowed plan selected, and the Subscribe price follows it.
class SSubscriptionPicker extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', () => this.#sync(), { signal: this.#ac.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const subscribe = this.querySelector('[data-purchase-subscribe]');
    const panel = this.querySelector('[data-subscribe-panel]');
    const select = this.querySelector('[data-selling-plan]');
    const on = Boolean(subscribe?.checked);
    if (panel) panel.hidden = !on;
    if (!(select instanceof HTMLSelectElement)) return;
    select.disabled = !on;
    if (select.selectedIndex < 0 && select.options.length) select.selectedIndex = 0;

    const option = select.options[select.selectedIndex];
    const priceEl = this.querySelector('[data-subscribe-price]');
    const compareEl = this.querySelector('[data-subscribe-compare]');
    if (option && priceEl && option.dataset.priceFormatted) priceEl.textContent = option.dataset.priceFormatted;
    if (option && compareEl) {
      const planPrice = Number(option.dataset.price);
      const basePrice = Number(this.dataset.variantPrice);
      compareEl.hidden = !(Number.isFinite(planPrice) && Number.isFinite(basePrice) && planPrice < basePrice);
    }
  }
}

if (!customElements.get('s-subscription-picker')) {
  customElements.define('s-subscription-picker', SSubscriptionPicker);
}
